import { BaseAgent } from 'agents';

const AuthAgent = {
    current: () => {
        return BaseAgent.get('/account');
    },
    logged: () => {
        return BaseAgent.get('/logged');
    },
    hasRequestedPrivacyDownload: () =>
        BaseAgent.get('/account/download_request').then(
            (response) => response.requested,
        ),
    subscription: () => BaseAgent.get('/payment/subscription'),
    confirmEmail: (token) => BaseAgent.post('/profile/confirmemail', { token }),
    recoverPassword: (email, url) => {
        let data = { email };

        if (url) {
            data.continue = url;
        }

        return BaseAgent.post('/profile/password/reset/init', data);
    },
    resetPassword: (uid, token, new_pass) =>
        BaseAgent.post('/profile/password/reset/complete', {
            uid,
            token,
            new_pass,
        }),
    login: ({ token, loginPayload }) =>
        BaseAgent.post('/login', loginPayload, (req) => {
            req.set('authorization', token);
        }),
    initAppleSignIn: () => BaseAgent.get('/init-apple-signin'),
    zendeskToken: () => BaseAgent.get('/zd_jwt_token'),
    logout: () => BaseAgent.post('/logout'),
    logoutAllDevices: () => BaseAgent.post('/logout_all_devices'),
    facebookLink: (token) =>
        BaseAgent.post('/facebook/link', { facebook_access_token: token }),
    facebookUnlink: () => BaseAgent.post('/facebook/unlink'),
    facebookLoginToken: ({ token, loginToken, loginPayload }) =>
        BaseAgent.post('/facebook/standalone/login/complete', {
            facebook_token: token,
            login_token: loginToken,
            ...loginPayload,
        }),
    facebookAccess: ({ token, loginPayload }) => {
        if (!token)
            return Promise.reject(new Error('No facebook_token provided'));

        return BaseAgent.post('/login', {
            facebook_access_token: token,
            ...loginPayload,
        });
    },
    getToken: (data) => BaseAgent.postJson('/token/new', data),
    tokenLogin: ({ token, loginPayload }) =>
        BaseAgent.post('/token/check', { token, ...loginPayload }),
    register: (data) => BaseAgent.post('/signup', data),
    save: (user) => BaseAgent.put('/user', { user }),
    leanplum_initialize: () => BaseAgent.post('/leanplum/user/initialize'),
};

export default AuthAgent;
